import { useHelperFunctions } from '@/composables/useHelperFunctions';
import { lsGet, lsRemove, lsSet } from '@/helpers/localStorageHelper';
import router from '@/router';
import axios from 'axios';

const { generateId } = useHelperFunctions();

const adminAxios = axios.create();

adminAxios.defaults.baseURL = TenantConfig.app_url;

adminAxios.interceptors.request.use(
  function (config) {
    config.headers = {
      Authorization: 'Bearer ' + lsGet('accessToken'),
    };

    let device_id = lsGet('device_id');
    if (!device_id) {
      device_id = generateId();
      lsSet('device_id', device_id);
    }

    config.params = {
      ...config.params,
      device_uid: device_id,
    };
    if (TenantConfig.tenant_key) {
      config.headers['X-Tenant-Key'] = TenantConfig.tenant_key;
      config.params.x_tenant_key = TenantConfig.tenant_key;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);
adminAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    if (error?.response?.data?.error?.code === 401) {
      lsRemove(['accessToken', 'logged', 'userData', 'permission']);
      await router.push({ name: 'login' }).then(() => {
        location.reload();
      });
    }

    return Promise.reject(error.response);
  },
);
export default adminAxios;
